import { InjectionToken } from '@angular/core';

export interface CapicheSubscriptionConfig {
  envName: string;
  baseStripeApiUrl: string;
  stripePriceId: string;
  openUrlHandler?: (url: string) => void;
}

export const CAPICHE_SUBSCRIPTION_CONFIG = new InjectionToken<CapicheSubscriptionConfig>('CapicheSubscriptionConfig');
